<template>
  <div class="DIntro inner_center">
    <h1 class="headline">
      潮国创意3D素材库 <br>
      用心打造高品质
    </h1>
    <div class="subhead">涵盖海报、场景、电商、元素、人物IP等全品类3D素材，打破传统设计天花板，让你赢在视觉！</div>
    <div class="intro-label kind">
      <div class="txt-label">种类丰富</div>
      <div class="txt-value">
        <span class="text-kind">海量多格式 </span>
        <span class="text-kind">多种类</span>
        <span class="text-kind">涵盖范围广</span>
      </div>
    </div>
    <div class="intro-label speed">
      <div class="txt-label">更新速度快</div>
      <div class="txt-value">
        每日实时更新
        <span class="text-3d">3D</span>
        素材库
      </div>
    </div>
    <div class="intro-label price">
      <div class="txt-label">价格优惠</div>
      <div class="txt-value">企业
        <span class="txt-price">VIP</span>
        低至
        <span class="txt-price">0.5</span>
        元一天</div>
    </div>
    <div class="intro-label business">
      <div class="txt-label">商用版权保障</div>
      <div class="txt-value">全用途全场景 版权保障</div>
    </div>

    <DModel class="DModel" />
  </div>
</template>

<script>
import DModel from '@/components/3d/d-model';

export default {
  name: "DIntro",
  components:{
    DModel
  }
}
</script>

<style lang="scss" scoped>
.DIntro{
  height: 763px;
  position: relative;
  z-index: 3;
  overflow: hidden;
  .headline{
    width: 533px;
    //height: 148px;
    font-size: 56px;
    font-weight: bold;
    color: #252626;
    line-height: 74px;
    letter-spacing: 4px;
    margin-bottom: 20px;
  }
  .subhead{
    width: 568px;
    //height: 64px;
    font-size: 20px;
    color: #252626;
    line-height: 32px;
    letter-spacing: 2px;
  }

  .intro-label{
    display: flex !important;
    flex-direction: row;
    padding: 46px 21px 0;
    box-sizing: border-box;

    &.kind{
      @include BgImage(84px,334px,'3d/intro-kind.png');
      @include Position(1,4,0,77px);
    }
    &.speed{
      @include BgImage(84px,272px,'3d/intro-speed.png');
      @include Position(1,4,144px,96px);
    }
    &.price{
      @include BgImage(84px,257px,'3d/intro-price.png');
      @include Position(1,4,284px,207px);
    }
    &.business{
      @include BgImage(84px,267px,'3d/intro-business.png');
      @include Position(1,4,424px,77px);
    }

    .txt-label{
      width: 16px;
      font-size: 16px;
      font-weight: bold;
      color: #213B40;
      margin-right: 10px;
      white-space: pre-wrap;
      margin-top: 2px;
      line-height: 18px;

    }
    .txt-value{
      width: 22px;
      font-size: 14px;
      color: #3D5457;
      line-height: 18px;
      letter-spacing: 1px;
      text-align: center;

      span{
        display: inline-block;
        &.text-kind{
          margin-bottom: 6px;
          &:last-child{
            margin-bottom: 0;
          }
        }

        &.text-3d{
          margin: 3px 0;
        }
        &.txt-price{
          margin: 2px 0;
        }
      }

    }
  }

  .DModel{
    @include Position(1,2,0px,0px);
    z-index: 20;
  }


  @include Screen(1){
    .headline{
      font-size: 52px;
      line-height: 69px;
      margin-bottom: 27px;
    }
    .subhead{
      font-size: 18px;
    }
    .intro-label{
      padding-top: 46px;

      &.kind{
        @include BgImage(84px,334px,'3d/intro-kind.png');
        @include Position(1,4,0,77px);
      }
      &.speed{
        @include BgImage(84px,272px,'3d/intro-speed.png');
        @include Position(1,4,144px,96px);
      }
      &.price{
        @include BgImage(84px,257px,'3d/intro-price.png');
        @include Position(1,4,284px,207px);
      }
      &.business{
        @include BgImage(84px,267px,'3d/intro-business.png');
        @include Position(1,4,424px,77px);
      }
    }
    .DModel{
      ::v-deep .img{
        width: 585px;
        height: 570px;
      }
    }
  }
}
</style>
